// import '@capacitor-community/http';
import { IonAlert, IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonLoading, IonPage, IonTextarea, IonTitle, IonToast, IonToggle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { arrowBack } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { empresaAlterar, empresaConfiguracoesCarregar, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './ConfiguracaoPedidos.css';

type Props = {
  abrirMenu: boolean;
};

const ConfiguracaoPedidos: React.FC<Props> = (props: Props) => {

  const history = useHistory();

  const [showToast2, setShowToast2] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [showLoading, setShowLoading] = useState(true);
  const [showSucesso, setShowSucesso] = useState(false);

  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [pedidoMinimo, setPedidoMinimo] = useState('');
  const [retirada, setRetirada] = useState<boolean>(false);
  const [agendamento, setAgendamento] = useState<boolean>(false);



  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarConta();
  });

  function carregarConta() {

    const consultar = async () => {

      console.log("carregarConta", loja);
      let id = loja;

      requestService(empresaConfiguracoesCarregar.url.replace("{id}", id.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: empresaConfiguracoesCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response);

          setPedidoMinimo(response.Item.pedidoMinimo || '');
          setRetirada(response.Item.retirada || false);
          setAgendamento(response.Item.agendamento || false);

          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }


  const cadastrar = () => {
    setShowToast2(true);
  }


  const onChangePedidoMinimo = (e: any) => {
    // e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");


    setPedidoMinimo(v);

  };


  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">


          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
          </IonButtons>


          <IonTitle slot="start">Configurações de {(window.localStorage.getItem("servicoTipoPlural") || "Projetos")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>



          {/* <IonItem lines="full">
            <IonLabel color="primary">{(window.localStorage.getItem("servicoTipoPlural") || "Projetos")}</IonLabel>
          </IonItem> */}

          <IonItem lines="none">

            <IonLabel position="stacked">Pedido mínimo</IonLabel>

            <IonTextarea
              style={{ "--background": "#eeeeee", "borderRadius": "5px", "padding": "10px" }}
              rows={1}
              value={pedidoMinimo}
              maxlength={50}
              placeholder="Valor do pedido mínimo"
              onIonChange={(e: any) => onChangePedidoMinimo(e)}
            />

          </IonItem>


          <IonItem lines="none">
            <IonLabel>Habilitar Retirada</IonLabel>

            <IonToggle slot="end"
              checked={retirada}
              onIonChange={(e: any) => {
                const isChecked = e.detail.checked;
                setRetirada(isChecked);
              }}
            />
          </IonItem>

          <IonItem lines="none">
            <IonLabel>Habilitar Agendamento</IonLabel>

            <IonToggle slot="end"
              checked={agendamento}
              onIonChange={(e: any) => {
                const isChecked = e.detail.checked;
                setAgendamento(isChecked);
              }}
            />
          </IonItem>


        </IonList>
        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonAlert isOpen={showToast2}
          onDidDismiss={() => setShowToast2(false)}
          header={'Alterar configurações'}
          message={'Você <strong>confirma</strong> a alteração?'}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: () => {

                setShowLoading(true);


                const objectRequest = {

                  pedidoMinimo,
                  retirada,
                  agendamento,

                };
                let id = loja;

                console.log("id", id)

                requestService(
                  empresaAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?tipo=pedidos"),
                  {
                    method: empresaAlterar.method,
                    body: JSON.stringify(objectRequest),
                    headers: [
                      ["token", window.localStorage.getItem("token")]
                    ],
                    credentials: 'include'
                  },
                  history,
                  (response: any) => {
                    console.log(response);
                    if (response) {
                      setTextToast("Alteração realizado com sucesso.");
                      setShowSucesso(true);

                    } else if (response.status === 400) {
                      console.log(response);
                      setTextToast("Ocorreu um erro ao efetuar a alteração.");
                      setShowToast(true);

                    }
                    setShowLoading(false);
                  },
                  (error: any) => {
                    console.log(error);
                    setTextToast("Ocorreu um erro ao efetuar a alteração.");
                    setShowToast(true);
                    setShowLoading(false);
                  })
              }
            }
          ]}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showSucesso}
          onDidDismiss={(e: any) => { setShowSucesso(false); history.goBack(); }}
          message={'Alterações salvas com sucesso!'}
          duration={3000}
          animated={false}
        />
      </IonContent >
      <IonFooter className="ion-no-border">
        <IonToolbar>
          <IonButton onClick={() => cadastrar()} expand="block" type="submit" hidden={acessos?.configuracoes != 'edicao'}>Salvar</IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage >
  );
};

export default ConfiguracaoPedidos;
